import { Component, EventEmitter, Input, Output } from '@angular/core'

export interface Value {
  label: string
  value: string | number
  icosDisabled?: boolean
  divided?: boolean
}
@Component({
  selector: 'icos-dropdown-item',
  template: `
    <li
      class="icos-dropdown-menu__item"
      [class.is-disabled]="model.icosDisabled"
      [class.icos-dropdown-menu__item--divided]="model.divided"
      (click)="handleClick($event)"
    >
      {{ model.label }}
    </li>
  `
})
export class IcosDropdownItem {
  @Input() model: Value
  @Output() selected: EventEmitter<any> = new EventEmitter<any>()

  handleClick(event: Event): void {
    if (this.model.icosDisabled) return
    event.stopPropagation()
    this.selected.emit(this.model)
  }
}
